var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MappingsEditComponent',{attrs:{"section-header-data":_vm.headers,"mapping-step-title":_vm.mappingStepTitle,"mapping-step-headers":_vm.mappingStepHeaders,"is-published":_vm.isPublished,"mapping-type":"inbound"}})}
var staticRenderFns = []

export { render, staticRenderFns }